var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 8.5C3 6.9406 3.44051 5.99131 4.05545 5.42029C4.68381 4.83682 5.65329 4.5 7 4.5H17C18.3467 4.5 19.3162 4.83682 19.9445 5.42029C20.5595 5.99131 21 6.9406 21 8.5V15.5C21 17.0594 20.5595 18.0087 19.9445 18.5797C19.3162 19.1632 18.3467 19.5 17 19.5H7C6.44772 19.5 6 19.9477 6 20.5C6 21.0523 6.44772 21.5 7 21.5H17C18.6533 21.5 20.1838 21.0868 21.3055 20.0453C22.4405 18.9913 23 17.4406 23 15.5V8.5C23 6.5594 22.4405 5.00869 21.3055 3.95471C20.1838 2.91318 18.6533 2.5 17 2.5H7C5.34671 2.5 3.81619 2.91318 2.69455 3.95471C1.55949 5.00869 1 6.5594 1 8.5C1 9.05228 1.44772 9.5 2 9.5C2.55228 9.5 3 9.05228 3 8.5Z",
    fill: "#011235"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7814 8.37589C18.126 8.80742 18.0556 9.43666 17.6241 9.78133L14.4928 12.2823C13.0983 13.3925 10.8917 13.3925 9.49715 12.2823L9.49469 12.2804L6.37469 9.78036C5.9437 9.43501 5.87427 8.80566 6.21962 8.37467C6.56497 7.94368 7.19431 7.87425 7.62531 8.2196L10.7439 10.7185C11.4094 11.2473 12.5814 11.2471 13.2466 10.718L16.3759 8.21862C16.8074 7.87395 17.4367 7.94436 17.7814 8.37589Z",
    fill: "#011235"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 11.5C1.44772 11.5 1 11.9477 1 12.5C1 13.0523 1.44772 13.5 2 13.5H5C5.55228 13.5 6 13.0523 6 12.5C6 11.9477 5.55228 11.5 5 11.5H2Z",
    fill: "#011235"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2 15.5C1.44772 15.5 1 15.9477 1 16.5C1 17.0523 1.44772 17.5 2 17.5H8C8.55228 17.5 9 17.0523 9 16.5C9 15.9477 8.55228 15.5 8 15.5H2Z",
    fill: "#011235"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.c63384d4bdcb1d95242ef251cc7b9055.svg";
export { ForwardRef as ReactComponent };